import MetaTags from "../../components/MetaTags";
import UserInfoPage from "../../features/web/userProfile/userInfo/UserInfoPage";

function UserInfo() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | البيانات الشخصيه"
                description="صفحة البيانات الشخصيه على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <UserInfoPage />
        </>
    );
}

export default UserInfo;
